import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=a6bf877c&scoped=true&"
import script from "./Gallery.vue?vue&type=script&lang=js&"
export * from "./Gallery.vue?vue&type=script&lang=js&"
import style0 from "./Gallery.vue?vue&type=style&index=0&id=a6bf877c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bf877c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GalleryPreview: require('/home/bitrix/frontend/components/gallery/GalleryPreview.vue').default,Preloader: require('/home/bitrix/frontend/components/other/Preloader.vue').default,GalleryFilters: require('/home/bitrix/frontend/components/gallery/GalleryFilters.vue').default,MtArrowLink: require('/home/bitrix/frontend/components/other/MtArrowLink.vue').default,ItemList: require('/home/bitrix/frontend/components/gallery/ItemList.vue').default,NotFound: require('/home/bitrix/frontend/components/gallery/NotFound.vue').default,Pagination: require('/home/bitrix/frontend/components/other/Pagination.vue').default})
